<template>
  <in-view
    class="show-more-button"
    :class="skipSlideIntoView ? '' : 'slide-into-view-transition'"
    :threshold="thresholdHeading"
    :threshold-type="'px'"
  >
    <div
      v-if="isVisible"
      class="row row--center"
    >
      <button
        class="button--40 button--combo"
        :class="onWhiteBg ? 'button--secondary' : 'button--white'"
        type="button"
        @click="getMoreData($event)"
      >
        <span> {{ buttonText }}</span>
        <svgicon
          v-if="!isLoading"
          name="Controls/Plus"
        />
        <svgicon
          v-else
          name="Misc/Loading-red-animated"
          class="loading"
        />
      </button>
    </div>

    <searchNotification
      v-if="isErrorMessage || noResultFound"
      :is-error-message="isErrorMessage"
    />
  </in-view>
</template>

<script>
  import searchNotification from "@/vue/components/common/searchNotification"
  import dataLayer from '@/analytics/dataLayer'
  import axios from 'axios'
  import "#/Controls/Plus"
  import "#/Misc/Loading-red-animated"

  export default {
    name: "ShowMore",
    components: {
      searchNotification
    },
    props: {
      skipSlideIntoView: {
        type: Boolean,
        default: false
      },
      // If button is on white background
      onWhiteBg: {
        type: Boolean,
        default: false
      },
      // Text for show more button
      buttonText: {
        type: String,
        default: "Visa fler"
      },
      /* Relative, ie "/api/search/inspiration"
       * If left empty, no api call will be made. */
      apiUrl: {
        type: String,
        default: null
      },
      tracking: {
        type: Object,
        default: function () {
          return {}
        }
      },
    },
    data () {
      return {
        isErrorMessage: false,
        noResultFound: false,
        isVisible: true,
        isLoading: false
      }
    },
    computed: {
      thresholdHeading () {
        return this.$root.isLargeViewport ? 32: 28
      }
    },
    watch: {
      apiUrl (newVal, oldVal) {
        // To clear all states for example between searches
        if (newVal !== oldVal) {
          this.isErrorMessage = false
          this.noResultFound = false
          this.isVisible = true
        }
      }
    },
    methods: {
      getMoreData: async function (event) {
        let keyboardClick = false
        if (event.detail === 0) {
          keyboardClick = true
        }

        // If no api url exists we simply skip api call and emit normal event
        if (!this.apiUrl) {
          this.trackClick(true)
          this.$emit("showMoreResult")
          return
        }

        try {
          this.isLoading = true
          let response = await axios.get(this.apiUrl)
          this.isLoading = false

          const hasResults = response.data.results && Object.entries(response.data.results).length > 0
          this.trackClick(hasResults)

          // Returns custom result and a bool telling you if the keyboard was used to click to button
          this.$emit("showMoreResult", response.data, keyboardClick)
        } catch (err){
          this.trackClick(false)
          console.log("error:", err)
          this.isLoading = false
          this.isErrorMessage = true
        }
      },
      trackClick (succeeded) {
        dataLayer.add({
          event: 'showMore',
          linkName: this.buttonText,
          succeeded: succeeded ? '1' : '0',
          ...this.tracking
        })
      }
    }
  }
</script>

<style lang="scss">
  .show-more-button {
    display: block;
    margin: 1.5rem 0;

    .button--40 {
      padding-top: 0;
      padding-bottom: 0;
    }

    .button--combo .svg-icon:last-child {
      margin-left: 0.25rem;
    }
  }

  .no-result {
    margin-top: 1rem;
  }
</style>
